import { render, staticRenderFns } from "./RoomUserSelect.vue?vue&type=template&id=95cfff06&scoped=true&"
import script from "./RoomUserSelect.vue?vue&type=script&lang=js&"
export * from "./RoomUserSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cfff06",
  null
  
)

export default component.exports